module.exports = __webpack_public_path__ + "static/user-tests-zoom-2d387328d4877343296c0553417927df.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/user-tests-zoom.png
// module id = 2702
// module chunks = 157636680307020